var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1587_3438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 9.875C15.7278 9.87445 16.4457 10.0436 17.0967 10.3691C17.7477 10.6946 18.3138 11.1674 18.75 11.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 11.75C1.68625 11.1674 2.25234 10.6946 2.90331 10.3691C3.55429 10.0436 4.27219 9.87445 5 9.875",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14.875C11.7259 14.875 13.125 13.4759 13.125 11.75C13.125 10.0241 11.7259 8.625 10 8.625C8.27411 8.625 6.875 10.0241 6.875 11.75C6.875 13.4759 8.27411 14.875 10 14.875Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625 17.375C6.07366 16.6136 6.71325 15.9825 7.48054 15.5441C8.24784 15.1056 9.11627 14.875 10 14.875C10.8837 14.875 11.7522 15.1056 12.5195 15.5441C13.2867 15.9825 13.9263 16.6136 14.375 17.375",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5781 6.75C12.695 6.29732 12.9365 5.88648 13.2751 5.56414C13.6138 5.24181 14.036 5.0209 14.4939 4.92649C14.9518 4.83209 15.427 4.86798 15.8656 5.03009C16.3041 5.1922 16.6884 5.47403 16.9748 5.84357C17.2612 6.21311 17.4382 6.65556 17.4858 7.12067C17.5333 7.58577 17.4495 8.0549 17.2439 8.47476C17.0382 8.89462 16.7189 9.2484 16.3223 9.49592C15.9256 9.74343 15.4675 9.87476 15 9.875",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99874 9.875C4.53121 9.87476 4.07311 9.74343 3.67648 9.49592C3.27984 9.2484 2.96056 8.89462 2.75489 8.47476C2.54922 8.0549 2.46541 7.58577 2.51297 7.12067C2.56054 6.65556 2.73757 6.21311 3.02396 5.84357C3.31036 5.47403 3.69464 5.1922 4.13317 5.03009C4.5717 4.86798 5.04689 4.83209 5.50479 4.92649C5.96269 5.0209 6.38495 5.24181 6.7236 5.56414C7.06225 5.88648 7.30373 6.29732 7.42062 6.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1587_3438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavCommunity);
export default __webpack_public_path__ + "static/media/nav-community.e3da75c77740ab082e5fe943ba8e9bd5.svg";
export { ForwardRef as ReactComponent };